import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable()
export class VersionService {
    private readonly http = inject(HttpClient);

    getVersion(): Observable<string> {
        return this.http.get<{ build: { version: string } }>(`${environment.api}/monitor`).pipe(
            map(({ build: { version } }) => version),
        );
    }
}
